<template>
	<div class="net-content">
		<img src="../../../static/img/network.png" />
		<span>链接不到网络</span>
		<button class="net-btn" @click="referNet">刷新网络</button>
	</div>
</template>

<script>
	export default {
	  name: 'Network',
	  meta:{page:true},
	  methods: {
	      referNet(){
	      	location.reload()
	      }
	  }
	}
</script>

<style>
	.net-content{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	    margin-top: 50%;
	    line-height: 5;
	}
	.net-btn{
		width:96px;
		height:28px;
		border-radius:16px;
		color: #009688;
		border:1px solid rgba(0,150,136,1);
	}
</style>


// WEBPACK FOOTER //
// src/components/page/NoNetwork.vue